import React, { useEffect } from "react";
import "./services.css";
import topBanner from "assets/services-image/services_top.png";
import Leads from "./Leads";
import Contact from "./Contact";
import Account from "./Account";
import Opportunity from "./Opportunity";
import Property from "./Property";
import Project from "./Project";
import Meta from "utils/meta";

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Services | The Realtor Desk" description="" />
      <div className="services-outer-container">
          <div className="services-banner">
              <div className="container">
                  <div className="services-banner--content">
                      <h1>Modern-Day Products Built To Empower Your Real Estate Business</h1>
                      <p>Customized real estate solutions backed by extensive research & cutting-edge technologies to optimize your team performance</p>
                  </div>
                  <div className="services-banner--image">
                      <img src={topBanner} alt="Modern-Day Products Built To Empower Your Real Estate Business" />
                  </div>
              </div>
          </div>
          <div className="container">
              <Leads />
              <Contact />
              <Account />
              <Opportunity />
              <Property />
              <Project />
          </div>
      </div>
    </>
  );
};

export default Services;
